/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { MetricDescriptor } from './export/MetricData';

export {
  Sum,
  LastValue,
  Histogram,
  ExponentialHistogram,
} from './aggregator/types';

export {
  AggregationSelector,
  AggregationTemporalitySelector,
} from './export/AggregationSelector';

export { AggregationTemporality } from './export/AggregationTemporality';

export {
  DataPoint,
  DataPointType,
  SumMetricData,
  GaugeMetricData,
  HistogramMetricData,
  ExponentialHistogramMetricData,
  ResourceMetrics,
  ScopeMetrics,
  MetricData,
  MetricDescriptor,
  CollectionResult,
} from './export/MetricData';

export { PushMetricExporter } from './export/MetricExporter';

export { MetricReader, MetricReaderOptions } from './export/MetricReader';

export {
  PeriodicExportingMetricReader,
  PeriodicExportingMetricReaderOptions,
} from './export/PeriodicExportingMetricReader';

export { InMemoryMetricExporter } from './export/InMemoryMetricExporter';

export { ConsoleMetricExporter } from './export/ConsoleMetricExporter';

export { MetricCollectOptions, MetricProducer } from './export/MetricProducer';

export { InstrumentType } from './InstrumentDescriptor';
/**
 * @deprecated Use {@link MetricDescriptor} instead.
 */
export type InstrumentDescriptor = MetricDescriptor;

export { MeterProvider, MeterProviderOptions } from './MeterProvider';

export {
  DefaultAggregation,
  ExplicitBucketHistogramAggregation,
  ExponentialHistogramAggregation,
  DropAggregation,
  HistogramAggregation,
  LastValueAggregation,
  SumAggregation,
  Aggregation,
} from './view/Aggregation';

export { View, ViewOptions } from './view/View';

export { TimeoutError } from './utils';
